import(/* webpackMode: "eager" */ "/workspace/src/app/account/referrals/page.tsx");
